import Echo from 'laravel-echo'

window.Pusher = require('pusher-js')

class EchoWrapper {
    install (Vue, { key, csrf_token, headers = {} }) {
        Vue.prototype.$echo = new Echo({
            auth: {
                headers
            },
            broadcaster: 'pusher',
            key,
            csrfToken: csrf_token,
            cluster: 'eu',
            forceTLS: true,
            namespace: ''
        })
    }
}

export default new EchoWrapper()
